const CTAB2b = () => {
    return (
        <section className="relative overflow-hidden py-28 mt-20 px-4 bg-gray-900 md:px-8">
            <div className="w-full h-full rounded-full bg-gradient-to-r from-[#58AEF1] to-pink-500 absolute -top-12 -right-14 blur-2xl opacity-10"></div>
            <div className="max-w-xl mx-auto text-center relative">
                <div className="py-4">
                    <h3 className="text-3xl text-gray-200 font-semibold md:text-5xl">
                        One partner. Multiple trades. Zero stress.
                    </h3>
                    <h4 className="text-lg text-gray-200 font-semibold md:text-xl mt-2">
  Ready to Simplify Your Property Maintenance?
</h4>
                    <p className="text-gray-300 leading-relaxed mt-3">
    Appliance, plumbing, electrical, HVAC — all covered by vetted, insured pros. Let's discuss how Matanato can serve your portfolio efficiently and professionally.
  </p>
                </div>
                <div className="mt-5 items-center justify-center gap-3 sm:flex">
                    <a 
                        href="#leadform"
                        className="block w-full mt-2 py-2.5 px-8 text-gray-700 bg-white rounded-md duration-150 hover:bg-gray-100 sm:w-auto"
                    >
                        Contact us
                    </a>
                    <a
                        href="tel:+13468002250"
                        className="block w-full mt-2 py-2.5 px-8 text-gray-300 bg-gray-700 rounded-md duration-150 hover:bg-gray-800 sm:w-auto"
                    >
                        Call Now
                    </a>
                </div>
                
            </div>
        </section>
    );
}

export default CTAB2b;
